/*!
 * Color mode toggler for CoreUI's docs (https://coreui.io/)
 * Copyright (c) 2024 creativeLabs Łukasz Holeczek
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 */

(() => {
  'use strict';

  const THEME = 'manifesto-theme';

  const getStoredTheme = () => localStorage.getItem(THEME);
  const setStoredTheme = (theme) => localStorage.setItem(THEME, theme);

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme();
    if (storedTheme) {
      return storedTheme;
    }

    return 'light';
  };

  const setTheme = (theme) => {
    if (theme === 'auto') {
      document.documentElement.setAttribute(
        'data-coreui-theme',
        window.matchMedia('(prefers-color-scheme: dark)').matches
          ? 'dark'
          : 'light',
      );
      document.documentElement.setAttribute(
        'data-bs-theme',
        window.matchMedia('(prefers-color-scheme: dark)').matches
          ? 'dark'
          : 'light',
      );
    } else {
      document.documentElement.setAttribute('data-coreui-theme', theme);
      document.documentElement.setAttribute('data-bs-theme', theme);
    }
  };

  setTheme(getPreferredTheme());

  const showActiveTheme = (theme) => {
    // data-coreui-theme-value="dark"
    const activeThemeBtn = document.getElementById('thema-toggle');
    if (!activeThemeBtn) {
      return;
    }
    const activeThemeIcon = activeThemeBtn.firstElementChild;
    if (theme === 'dark') {
      activeThemeBtn.dataset.coreuiThemeValue = 'light';
      activeThemeIcon.classList = 'fas fa-sun';
    } else {
      activeThemeBtn.dataset.coreuiThemeValue = 'dark';
      activeThemeIcon.classList = 'fas fa-moon';
    }
  };

  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', () => {
      const storedTheme = getStoredTheme();
      if (storedTheme !== 'light' && storedTheme !== 'dark') {
        setTheme(getPreferredTheme());
      }
    });

  window.addEventListener('DOMContentLoaded', () => {
    showActiveTheme(getPreferredTheme());

    document.querySelectorAll('[data-coreui-theme-value]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const theme = toggle.getAttribute('data-coreui-theme-value');
        setStoredTheme(theme);
        setTheme(theme);
        showActiveTheme(theme);
      });
    });
  });
})();
